import { render, staticRenderFns } from "./schoolApplication.vue?vue&type=template&id=cadd292e&scoped=true"
import script from "./schoolApplication.vue?vue&type=script&lang=js"
export * from "./schoolApplication.vue?vue&type=script&lang=js"
import style0 from "./schoolApplication.vue?vue&type=style&index=0&id=cadd292e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadd292e",
  null
  
)

export default component.exports